<template>
    <div class="globient-detail-page globient-logistics-page">
        <el-row>
            <el-col :span="24">
                <div class="grid-content bg-purple-light">
                    <div class="page-title">
                        <b>Globient 물류 출고</b>
                    </div>

                    <div class="search-row">
                        <span class="label">작업 일자</span>
                        <el-date-picker
                            v-model="confirmStartDateOption"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="시작일"
                        />
                        <span>~</span>
                        <el-date-picker
                            v-model="confirmEndDateOption"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="종료일"
                        />
                    </div>

                    <div class="search-row">
                        <span class="label">판매처</span>
                        <div class="search-select-wrap">
                            <el-select
                                v-model="customerInfoSeqInput"
                                :loading="loading"
                                size="small"
                                placeholder="판매처 선택"
                            >
                                <el-option
                                    v-for="item in customerOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                />
                            </el-select>

                            <el-button
                                v-if="customerInfoSeqInput"
                                icon="el-icon-refresh-left"
                                size="mini"
                                circle
                                class="reset-btn"
                                @click="customerInfoSeqInput=null"
                                title="초기화"
                            ></el-button>
                        </div>
                    </div>

                    <div class="search-row">
                        <span class="label">주문번호</span>
                        <el-input
                            v-model="orderNumberInput"
                            class="order-number-search-input"
                            placeholder="주문번호"
                        />
                    </div>

                    <div class="search-row">
                        <span class="label">QR CODE</span>
                        <el-input v-model="barcodeInput" class="qr-search-input" />
                    </div>

                    <div class="search-actions">
                        <el-button :loading="loading" type="primary" @click="search">조회</el-button>
                        <el-tag type="warning" effect="dark">QR코드 리딩 건수 합계 : {{ totalCount }}</el-tag>
                    </div>
                </div>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="24">
                <div class="grid-content bg-purple-light globient-table-panel">
                    <el-table
                        v-loading="loading"
                        ref="multipleTable"
                        class="globient-table"
                        :data="tableData"
                        border
                        size="small"
                        style="width: 100%"
                        :row-style="{ minHeight: '42px' }"
                        :cell-style="{ padding: '6px 8px' }"
                        :header-cell-style="{
                            background: '#2F384E',
                            color: '#fff',
                            height: '34px',
                            padding: '4px 8px'
                        }"
                        @selection-change="handleSelectionChange"
                    >
                        <el-table-column type="selection" width="44" />
                        <el-table-column property="seq" label="일련번호" width="60" />
                        <el-table-column label="작업시간" width="180" class-name="work-time-column">
                            <template #default="scope">
                                {{ scope.row.logistics_out_date_ktng ? scope.row.logistics_out_date_ktng.substring(0, 16) : '' }}
                            </template>
                        </el-table-column>
                        <el-table-column property="store" label="판매처" min-width="160" show-overflow-tooltip>
                            <template #default="scope">
                                <el-button type="text" size="small" @click="openDetailDialog(scope.row)">
                                    {{ scope.row.store }}
                                </el-button>
                            </template>
                        </el-table-column>
                        <el-table-column property="country" label="품목" min-width="270" show-overflow-tooltip>
                            <template #default="scope">
                                <el-button type="text" size="small" @click="openDetailDialog(scope.row)">
                                    {{ scope.row.country }}
                                </el-button>
                            </template>
                        </el-table-column>
                        <el-table-column property="order_number" label="주문번호" min-width="150" show-overflow-tooltip>
                            <template #default="scope">
                                <el-input
                                    v-model="scope.row.order_number"
                                    size="small"
                                    class="table-order-number-input"
                                />
                            </template>
                        </el-table-column>
                        <el-table-column property="count" label="QR코드 리딩 건수" width="180">
                            <template #default="scope">
                                <el-button type="text" size="small" @click="openDetailDialog(scope.row)">
                                    {{ scope.row.count }}
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div class="pagination table-actions">
                        <el-pagination
                            small
                            layout="prev, pager, next"
                            :total="totalSize"
                            :page-size="pageSize"
                            :current-page.sync="currentPage"
                            @current-change="handleCurrentChange"
                        />

                        <el-button :loading="loading" type="primary" @click="openBoxMappingDialog">
                            박스매핑
                        </el-button>
                        <el-button :loading="loading" type="primary" @click="updateOrderNumberList">
                            주문번호 수정
                        </el-button>
                        <el-button :loading="loading" type="primary" @click="handleDelete">
                            삭제
                        </el-button>
                        <el-button :loading="loading" type="primary" @click="excelDownFuncAll">
                            엑셀 다운로드
                        </el-button>
                        <el-tag type="warning" effect="dark">
                            TOTAL COUNT : {{ totalData.length }}
                        </el-tag>
                    </div>

                    <el-dialog
                        title="박스매핑"
                        :visible.sync="dialogVisible"
                        width="96vw"
                        top="0.5vh"
                        v-loading="loading"
                        :close-on-click-modal="false"
                        custom-class="rounded-dialog box-mapping-dialog"
                    >
                        <div class="mapping-customer-row">
                            <span>*판매처 :</span>
                            <el-select
                                v-model="selectedCustomerInfoSeq"
                                clearable
                                placeholder="판매처 선택"
                            >
                                <el-option
                                    v-for="item in customerOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                />
                            </el-select>
                        </div>

                        <div class="mapping-customer-row">
                            <span>*주문번호:</span>
                            <el-input
                                v-model="selectedOrderNumber"
                                class="order-number-input"
                                placeholder="주문번호를 입력하세요"
                                clearable
                            />
                        </div>

                        <el-input
                            v-model="barcode"
                            class="textarea_class"
                            type="textarea"
                            :rows="10"
                            placeholder="BOX BARCODE 또는 QR CODE를 스캔하세요"
                            lang="en"
                            inputmode="url"
                            autocorrect="off"
                            autocapitalize="off"
                            spellcheck="false"
                        />

                        <div class="mapping-action-row">
                            <div class="qr-count">리딩된 CODE COUNT : {{ barcodeCount }}</div>
                            <el-button type="primary" @click="applyCustomer">등록</el-button>
                        </div>
                    </el-dialog>

                    <el-dialog
                        title="물류 출고 상세"
                        :visible.sync="detailDialogVisible"
                        width="96vw"
                        top="0.5vh"
                        v-loading="loading"
                        :close-on-click-modal="false"
                        custom-class="rounded-dialog box-mapping-dialog"
                    >
                        <div class="detail-info-row">
                            <span>판매처 : {{ detailStore }}</span>
                            <span>품목 : {{ detailCountry }}</span>
                            <span>주문번호 : {{ detailOrderNumber }}</span>
                            <span>물류 출고 시간 : {{ detailLogisticsOutDate }}</span>
                        </div>
                        <div class="detail-info-row">
                            <span>판매처 수정 :</span>
                            <el-select
                                v-model="detailSelectedCustomerInfoSeq"
                                placeholder="판매처 선택"
                            >
                                <el-option
                                    v-for="item in customerOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                />
                            </el-select>
                        </div>
                        <div class="detail-info-row">
                            <span>주문번호 수정 :</span>
                            <el-input
                                v-model="detailOrderNumber"
                                class="order-number-input"
                                placeholder="주문번호를 입력하세요"
                                clearable
                            />
                        </div>
                        <div class="detail-info-row">
                            <span>BOX BARCODE : {{ detailLetNo }}</span>
                        </div>

          <el-input
              v-model="detailBarcode"
              class="textarea_class"
              type="textarea"
              :rows="10"
              placeholder="BOX BARCODE 또는 QR CODE를 입력하세요"
          />

          <div class="mapping-action-row">
            <div class="qr-count">입력 CODE COUNT : {{ detailBarcodeCount }}</div>
            <el-button type="primary" @click="updateLogisticsOutGroup">수정 저장</el-button>
          </div>
                    </el-dialog>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import Axios from 'axios';
import XLSX from 'xlsx';

export default {
    created() {
        this.$store.commit('dayBefore', 0);
        this.confirmEndDateOption = this.$store.state.dateOption;
        this.$store.commit('dayBefore', 7);
        this.confirmStartDateOption = this.$store.state.dateOption;
        this.loadCustomers();
        this.search();
    },

    computed: {
        totalCount() {
            return this.totalData.reduce((sum, item) => sum + (Number(item.count) || 0), 0);
        },

        barcodeCount() {
            return this.getScannedCodes().length;
        },

        detailBarcodeCount() {
            return (this.detailBarcode || '')
                .split(/\r?\n/)
                .map((code) => code.trim())
                .filter(Boolean)
                .length;
        }
    },

    data() {
        return {
            loading: false,
            confirmStartDateOption: '',
            confirmEndDateOption: '',
            customerInfoSeqInput: null,
            barcodeInput: '',
            orderNumberInput: '',
            customerOptions: [],
            selectedCustomerInfoSeq: null,
            selectedOrderNumber: '',
            dialogVisible: false,
            barcode: '',
            detailDialogVisible: false,
            detailStore: '',
            detailCountry: '',
            detailOrderNumber: '',
            detailLogisticsOutDate: '',
            detailGroupSeq: '',
            detailSelectedCustomerInfoSeq: null,
            detailLetNo: '',
            detailBarcode: '',
            multipleSelection: [],
            totalData: [],
            tableData: [],
            currentPage: 1,
            pageSize: 10,
            totalSize: 0
        };
    },

    methods: {
        async loadCustomers() {
            const reqJson = { user_seq: 174 };
            await Axios.post(this.$url + '/authStoreInfo/globientCustomerlist', reqJson, this.$store.state.config)
                .then((res) => {
                    const rows = res.data.authStoreInfoDTO || [];
                    this.customerOptions = rows.map((row) => ({
                        value: row.auth_store_info_seq,
                        label: row.store.trim()
                    }));
                })
                .catch(() => {
                    this.$message.error(this.$store.state.serverErrorMessage);
                });
        },

        async search() {
            this.loading = true;
            const reqJson = {
                in_start_date: this.confirmStartDateOption,
                in_end_date: this.confirmEndDateOption,
                customer_info_seq: this.customerInfoSeqInput,
                barcode: this.barcodeInput.replace(/\s+/g, ''),
                order_number: this.orderNumberInput.trim(),
                user_seq: 174
            };

            await Axios.post(this.$url + '/authStoreBarcodeInfo/logisticsPendingList', reqJson, this.$store.state.config)
                .then((res) => {
                    const rows = res.data.authStoreBarcodeInfoDTO || [];
                    this.totalData = rows.map((row, index) => ({
                        seq: index + 1,
                        logistics_out_date_group_seq: row.logistics_out_date_group_seq,
                        logistics_out_date_ktng: row.logistics_out_date_ktng,
                        store: row.store,
                        country: row.country,
                        order_number: row.order_number,
                        count: row.count,
                        user_seq: row.user_seq
                    }));
                    this.totalSize = this.totalData.length;
                    this.currentPage = 1;
                    this.tableData = this.totalData.slice(0, this.pageSize);
                })
                .catch(() => {
                    this.$message.error(this.$store.state.serverErrorMessage);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getScannedCodes() {
            return [...new Set(
                (this.barcode || '')
                    .split(/\r?\n/)
                    .map((code) => code.trim())
                    .filter(Boolean)
            )];
        },

        openBoxMappingDialog() {
            this.selectedCustomerInfoSeq = null;
            this.selectedOrderNumber = '';
            this.barcode = '';
            this.dialogVisible = true;
        },

        async openDetailDialog(row) {
            this.detailStore = row.store || '';
            this.detailCountry = row.country || '';
            this.detailOrderNumber = row.order_number || '';
            this.detailLogisticsOutDate = row.logistics_out_date_ktng
                ? row.logistics_out_date_ktng.substring(0, 16)
                : '';
            this.detailGroupSeq = row.logistics_out_date_group_seq || '';
            this.detailSelectedCustomerInfoSeq = null;
            this.detailLetNo = '';
            this.detailBarcode = '';
            this.loading = true;

            await Axios.post(this.$url + '/authStoreBarcodeInfo/getLogisticsOutBarcodeList', {
                logistics_out_date_group_seq: row.logistics_out_date_group_seq,
                user_seq: 174
            }, this.$store.state.config)
                .then((res) => {
                    const rows = res.data.authStoreBarcodeInfoDTO || [];
                    this.detailSelectedCustomerInfoSeq = rows.length > 0
                        ? rows[0].customer_info_seq
                        : null;
                    this.detailOrderNumber = rows.length > 0
                        ? rows[0].order_number || ''
                        : this.detailOrderNumber;
                    this.detailLetNo = [...new Set(
                        rows
                            .map((item) => item.letNo)
                            .filter((letNo) => letNo && letNo.length < 20)
                    )].join(', ');
                    this.detailBarcode = rows
                        .map((item) => item.barcode)
                        .filter(Boolean)
                        .join('\n');
                    this.detailDialogVisible = true;
                })
                .catch(() => {
                    this.$message.error(this.$store.state.serverErrorMessage);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getDetailBarcodes() {
            return [...new Set(
                (this.detailBarcode || '')
                    .split(/\r?\n/)
                    .map((code) => code.trim())
                    .filter(Boolean)
            )];
        },

        async updateLogisticsOutGroup() {
            if (!this.detailSelectedCustomerInfoSeq) {
                this.$message.error('판매처를 선택해 주세요.');
                return;
            }
            const detailOrderNumber = (this.detailOrderNumber || '').trim();
      const barcodes = this.getDetailBarcodes();
      if (barcodes.length === 0) {
        this.$message.error('BOX BARCODE 또는 QR CODE를 한 건 이상 입력해 주세요.');
        return;
      }

            const reqJson = barcodes.map((barcode) => ({
                barcode,
                logistics_out_date_group_seq: this.detailGroupSeq,
                customer_info_seq: this.detailSelectedCustomerInfoSeq,
                order_number: detailOrderNumber,
                user_seq: 174
            }));

            this.loading = true;
            await Axios.post(this.$url + '/authStoreBarcodeInfo/updateLogisticsOutGroup', reqJson, this.$store.state.config)
                .then((res) => {
        if (res.data <= 0) {
          this.$message.error(this.getLogisticsOutErrorMessage(res.data));
          return;
        }
                    this.$message.success(res.data + '건 수정되었습니다.');
                    this.detailDialogVisible = false;
                    this.search();
                })
                .catch(() => {
                    this.$message.error(this.$store.state.serverErrorMessage);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        handleCurrentChange(page) {
            const start = (page - 1) * this.pageSize;
            this.tableData = this.totalData.slice(start, start + this.pageSize);
        },

        handleSelectionChange(rows) {
            this.multipleSelection = rows;
        },

        async updateOrderNumberList() {
            if (this.multipleSelection.length === 0) {
                this.$message.error('수정할 데이터를 선택해 주세요.');
                return;
            }

            const reqJson = this.multipleSelection
                .map((item) => ({
                    logistics_out_date_group_seq: item.logistics_out_date_group_seq,
                    order_number: (item.order_number || '').trim(),
                    user_seq: 174
                }))
                .filter((item) => item.logistics_out_date_group_seq);

            if (reqJson.length === 0) {
                this.$message.error('수정할 데이터가 없습니다.');
                return;
            }

            this.loading = true;
            await Axios.post(this.$url + '/authStoreBarcodeInfo/updateLogisticsOutOrderNumberList', reqJson, this.$store.state.config)
                .then((res) => {
                    if (res.data <= 0) {
                        this.$message.error('주문번호 수정에 실패했습니다.');
                        return;
                    }
                    this.$message.success(res.data + '건 주문번호를 수정했습니다.');
                    this.search();
                })
                .catch(() => {
                    this.$message.error(this.$store.state.serverErrorMessage);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        handleDelete() {
            if (this.multipleSelection.length === 0) {
                this.$message.error('데이터를 선택해 주세요.');
                return;
            }

            this.$confirm('판매처 매핑과 물류 출고 작업일자를 초기화하시겠습니까?', '경고', {
                confirmButtonText: '초기화',
                cancelButtonText: '취소',
                type: 'warning',
                customClass: 'globient-reset-confirm'
            }).then(() => {
                this.remove();
            }).catch(() => {});
        },

        async remove() {
            this.loading = true;
            await Axios.post(this.$url + '/authStoreBarcodeInfo/resetLogisticsOut', this.multipleSelection, this.$store.state.config)
                .then((res) => {
                    this.$message.success(res.data + '건 초기화 되었습니다.');
                    this.search();
                })
                .catch(() => {
                    this.$message.error(this.$store.state.serverErrorMessage);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        async excelDownFuncAll() {
            this.loading = true;
            const reqJson = {
                in_start_date: this.confirmStartDateOption,
                in_end_date: this.confirmEndDateOption,
                customer_info_seq: this.customerInfoSeqInput,
                barcode: this.barcodeInput.replace(/\s+/g, ''),
                order_number: this.orderNumberInput.trim(),
                user_seq: 174
            };

            await Axios.post(this.$url + '/authStoreBarcodeInfo/getLogisticsListForExcel', reqJson, this.$store.state.config)
                .then((res) => {
                    const rows = res.data.authStoreBarcodeInfoDTO || [];
                    const excelData = rows.map((row, index) => ({
                        일련번호: index + 1,
                        작업일자: row.logistics_out_date_ktng ? row.logistics_out_date_ktng.substring(0, 16) : '',
                        판매처: row.store,
                        품목: row.country,
                        주문번호: row.order_number,
                        'BOX BARCODE': row.letNo,
                        'QR CODE': row.barcode
                    }));
                    const worksheet = XLSX.utils.json_to_sheet(excelData);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, '글로비언트물류출고');
                    XLSX.writeFile(workbook, '글로비언트물류출고.xlsx');
                })
                .catch(() => {
                    this.$message.error(this.$store.state.serverErrorMessage);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        async applyCustomer() {
            if (!this.selectedCustomerInfoSeq) {
                this.$message.error('판매처를 선택해 주세요.');
                return;
            }
            const orderNumber = (this.selectedOrderNumber || '').trim();
            const scannedCodes = this.getScannedCodes();
            if (scannedCodes.length === 0) {
                this.$message.error('BOX BARCODE 또는 QR CODE를 스캔해 주세요.');
                return;
            }

            const reqJson = scannedCodes.map((code) => ({
                letNo: code,
                user_seq: 174,
                customer_info_seq: this.selectedCustomerInfoSeq,
                order_number: orderNumber
            }));

            this.loading = true;
            await Axios.post(this.$url + '/authStoreBarcodeInfo/updateCustomerInfo', reqJson, this.$store.state.config)
                .then((res) => {
                    if (res.data <= 0) {
                        this.$message.error(this.getLogisticsOutErrorMessage(res.data));
                        return;
                    }
                    this.$message.success(res.data + '건 판매처가 적용되었습니다.');
                    this.selectedCustomerInfoSeq = null;
                    this.selectedOrderNumber = '';
                    this.barcode = '';
                    this.dialogVisible = false;
                    this.search();
                })
                .catch(() => {
                    this.$message.error(this.$store.state.serverErrorMessage);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getLogisticsOutErrorMessage(resultCode) {
            if (resultCode === -2) {
                return '등록되지 않았거나 출고 대상이 아닌 QR CODE가 포함되어 전체 처리를 취소했습니다.';
            }
            if (resultCode === -3) {
                return '이미 기 출고된 QR CODE가 포함되어 전체 처리를 취소했습니다.';
            }
            return '처리할 수 없는 BOX BARCODE 또는 QR CODE가 포함되어 전체 처리를 취소했습니다.';
        }
    }
};
</script>

<style>
.globient-detail-page {
    width: 100%;
    padding: 8px 12px 14px;
    box-sizing: border-box;
    background: #f4f7fb;
}

.globient-logistics-page {
    overflow-x: hidden;
}

.globient-detail-page .grid-content.bg-purple-light {
    background: #ffffff;
    border: 1px solid #e3e8f0;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(31, 45, 61, 0.06);
}

.page-title {
    padding: 14px 18px;
    border-bottom: 1px solid #edf1f6;
    font-size: 20px;
}

.search-row,
.search-actions,
.table-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 7px 14px;
}

.label {
    width: 80px;
    font-weight: 700;
    color: #536170;
}

.qr-search-input {
    width: 400px !important;
    flex: 0 0 400px;
}

.qr-search-input .el-input__inner {
    width: 400px !important;
}

.order-number-search-input {
    width: 195px !important;
    flex: 0 0 195px;
}

.order-number-search-input .el-input__inner {
    width: 195px !important;
}

.order-number-input {
    width: 195px !important;
    flex: 0 0 195px;
}

.order-number-input .el-input__inner {
    width: 195px !important;
}

.table-order-number-input {
    width: 160px !important;
}

.table-order-number-input .el-input__inner {
    width: 160px !important;
}

.search-select-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
}

.globient-table-panel {
    width: 100%;
    margin-top: 10px;
    overflow: hidden;
}

.globient-table {
    width: 100% !important;
    font-size: 13px;
}

.globient-table .el-table__header th {
    font-weight: 700;
    padding: 0 !important;
}

.globient-table .el-table__body td {
    line-height: 1.45;
    vertical-align: middle;
    padding: 0 !important;
}

.globient-table .el-table__header th > .cell,
.globient-table .el-table__body td > .cell {
    padding: 0 10px !important;
    white-space: normal;
    word-break: keep-all;
    justify-content: flex-start;
}

.globient-table .el-table-column--selection .cell {
    justify-content: center;
    padding: 0 !important;
}

.globient-table .work-time-column .cell {
    min-height: 32px;
}

.globient-table .el-button--text {
    color: #1d5fbf;
    font-weight: 700;
    padding: 0 !important;
    margin: 0 !important;
    line-height: inherit;
}

.globient-detail-page .pagination {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px 12px;
}

.table-actions {
    border-top: 1px solid #edf1f6;
}

.mapping-customer-row,
.mapping-action-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
    font-size: 20px;
    font-weight: 700;
}

.detail-info-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 24px;
    margin-bottom: 12px;
    font-size: 18px;
    font-weight: 700;
}

.mapping-action-row {
    margin-top: 12px;
}

.box-mapping-dialog .textarea_class .el-textarea__inner {
    min-height: 58vh !important;
    font-size: 21px;
    line-height: 1.5;
}

.qr-count {
    font-size: 20px;
    font-weight: 700;
}

.globient-reset-confirm .el-message-box__btns {
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    gap: 10px;
}

.globient-reset-confirm .el-message-box__btns .el-button {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: auto !important;
    min-width: 80px;
    height: 40px;
    margin: 0 !important;
}
</style>
